import React, { Component } from 'react';
import '../../../dist/assets/stylesheets/css/decoration.css'
function Spinner() {
    return <div className='spinner-container parent-container'><span id="spinner"></span></div>;
}

export default Spinner;